
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kiacarenceonrent() {



    const cardData =
    {
        keyword: ' Kia Carens On Rent in Pune ',
        heading: 'Skyline Cabs: Kia Carens On Rent in Pune',
        headingDescription: 'Skyline Cabs offers premium and spacious Kia Carens on Rent in Pune for a stylish and comfortable travel experience. Perfect for family trips, group outings, or corporate travel, our well-maintained Kia Carens vehicles provide ample legroom, modern features, and a smooth ride. With professional drivers, flexible rental packages, transparent pricing, and 24/7 customer support, Skyline Cabs ensures a hassle-free journey every time. Book your Kia Carens in Pune today and travel in comfort, style, and safety.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Kia Carens Car Rental Service in Pimpri Chinchwad",
      "description": "Skyline Cabs offers premium Kia Carens rental services in Pimpri Chinchwad, perfect for family trips, airport transfers, or corporate pickups. Enjoy spacious 7-seater comfort, professional drivers, and flexible booking options with transparent pricing."
    },
    {
      "name": "Kia Carens on Rent in Pune for Outstation",
      "description": "Book a Kia Carens for your next outstation trip from Pune with Skyline Cabs. Ideal for group travel, this MPV comes with ample boot space, air conditioning, and a professional driver to ensure a comfortable and safe journey."
    },
    {
      "name": "Kia Carens on Hire for Corporate Events",
      "description": "Skyline Cabs provides Kia Carens on hire for corporate events, business travel, and VIP pickups in Pune. Impress your clients or partners with this premium ride, complete with punctual service and customizable billing options."
    },
    {
      "name": "Pune to Mahabaleshwar Kia Carens on Rent",
      "description": "Travel in style from Pune to Mahabaleshwar with a Kia Carens from Skyline Cabs. Enjoy scenic views and hill-road comfort in this 7-seater vehicle with experienced drivers and all-terrain readiness."
    },
    {
      "name": "Pune to Shirdi Kia Carens on Rent",
      "description": "Book a Kia Carens from Pune to Shirdi with Skyline Cabs for a spiritual and peaceful journey. Our well-maintained MPVs are ideal for family pilgrimages, with safety, legroom, and reliability built in."
    },
    {
      "name": "Pune to Outstation Kia Carens on Rent",
      "description": "Whether it's Goa, Nashik, Mumbai, or beyond, Skyline Cabs offers Kia Carens for outstation rentals from Pune. Comfortable for up to 7 passengers and driven by courteous chauffeurs, perfect for weekend getaways."
    },
    {
      "name": "Cab Service in Pune Kia Carens on Rent",
      "description": "Skyline Cabs provides Kia Carens for cab services in Pune for local and intercity travel. Experience luxury at affordable rates with prompt service, clean cars, and multiple pickup points across the city."
    },
    {
      "name": "Kia Carens on Rent in Pimpri Chinchwad",
      "description": "Book a Kia Carens from Pimpri Chinchwad with Skyline Cabs. Whether it’s a day tour or an outstation plan, we offer well-maintained vehicles with experienced drivers and flexible pricing packages."
    },
    {
      "name": "7 Seater Kia Carens on Rent in Pune",
      "description": "Looking for a reliable 7-seater? Rent a Kia Carens in Pune with Skyline Cabs for business, leisure, or family trips. Enjoy maximum comfort, smooth rides, and extra legroom with top-class support."
    },
    {
      "name": "Pune Local Kia Carens on Rent",
      "description": "Need a full-day ride in Pune? Rent a Kia Carens locally with Skyline Cabs for shopping sprees, business meetings, or Pune Darshan. Choose hourly or day-long rental plans with door-to-door service."
    },
    {
      "name": "Pune to Outstation Kia Carens Taxi Fare per km",
      "description": "Skyline Cabs offers competitive per-kilometer taxi fares for Kia Carens on outstation trips from Pune. Rates start at ₹14/km with options for round trips, driver night charges, and tolls calculated transparently."
    },
    {
      "name": "Kia Carens Car Rental Pune",
      "description": "Skyline Cabs specializes in Kia Carens car rental services in Pune for tourists, locals, and corporate users. Book hourly, daily, or intercity with easy online booking and full customer support."
    },
    {
      "name": "Kia Carens on Rent in Hinjewadi",
      "description": "Skyline Cabs offers premium Kia Carens rentals in Hinjewadi for IT employees, tech parks, and residents. Punctual pickups, executive vehicles, and 24x7 availability make it ideal for professionals."
    },
    {
      "name": "Kia Carens on Rent in Kharadi Pune",
      "description": "Book a Kia Carens in Kharadi with Skyline Cabs for airport transfers, outstation rides, or group travel. Spacious interiors and luggage space make it a top choice for families and professionals alike."
    },
    {
      "name": "Car Hire Agency in Viman Nagar Pune",
      "description": "Skyline Cabs operates as a top-rated car hire agency in Viman Nagar, offering Kia Carens and other premium vehicles for rent. Perfect for airport transfers, family outings, and outstation travel from east Pune."
    },
    {
      "name": "Kia Carens on Rent in Magarpatta City",
      "description": "Rent a Kia Carens from Magarpatta City with Skyline Cabs for comfortable and reliable travel. Whether it's a trip to Mumbai, Mahabaleshwar, or a corporate booking, we've got the perfect ride for you."
    }
  ],
  "tableData": [
    ["Kia Carens Car Rental Service in Pimpri Chinchwad", "Kia Carens on Rent in Pune for Outstation"],
    ["Kia Carens on Hire for Corporate Events", "Pune to Mahabaleshwar Kia Carens on Rent"],
    ["Pune to Shirdi Kia Carens on Rent", "Pune to Outstation Kia Carens on Rent"],
    ["Cab Service in Pune Kia Carens on Rent", "Kia Carens on Rent in Pimpri Chinchwad"],
    ["7 Seater Kia Carens on Rent in Pune", "Pune Local Kia Carens on Rent"],
    ["Pune to Outstation Kia Carens Taxi Fare per km", "Kia Carens Car Rental Pune"],
    ["Kia Carens on Rent in Hinjewadi", "Kia Carens on Rent in Kharadi Pune"],
    ["Car Hire Agency in Viman Nagar Pune", "Kia Carens on Rent in Magarpatta City"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Kia Carens Rental Service in Pune",
        "WhyChoosedescription": "We offer dependable and punctual Kia Carens rental services in Pune, ideal for family outings, business trips, airport transfers, and weekend getaways."
    },
    {
        "WhyChooseheading": "Spacious and Premium Comfort",
        "WhyChoosedescription": "The Kia Carens is a stylish and comfortable MPV with ample legroom, modern interiors, and a smooth drive—perfect for city rides or long-distance travel."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "All our Kia Carens are regularly maintained and sanitized before every trip to ensure a hygienic, smooth, and trouble-free ride experience."
    },
    {
        "WhyChooseheading": "Professional and Polite Drivers",
        "WhyChoosedescription": "Our drivers are experienced, courteous, and well-acquainted with Pune and surrounding routes to ensure your journey is safe, comfortable, and efficient."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy fixed, budget-friendly pricing with no hidden fees. Our rental packages are designed to provide maximum comfort without stretching your wallet."
    },
    {
        "WhyChooseheading": "Flexible Rental Options",
        "WhyChoosedescription": "Book a Kia Carens for half-day, full-day, or outstation trips. We offer flexible hourly, daily, and mileage-based packages to suit your specific needs."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Booking",
        "WhyChoosedescription": "Our rental service is available round-the-clock. Whether you need a car at dawn or midnight, we’re just a call or click away with prompt support."
    },
    {
        "WhyChooseheading": "Perfect for All Travel Needs",
        "WhyChoosedescription": "Whether it’s a corporate ride, family vacation, wedding travel, or sightseeing trip, Kia Carens offers a premium experience for every occasion."
    }
]























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Kia Carens in Pune with Skyline Cabs?',
            answer:
                'You can easily rent a Kia Carens in Pune through Skyline Cabs by visiting our website, using our mobile app, or contacting our customer support. Choose Kia Carens as your preferred vehicle, enter your travel details, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What makes Kia Carens a good choice for rental in Pune?',
            answer:
                'Kia Carens is known for its stylish design, spacious interiors, advanced safety features, and smooth ride. It’s perfect for family trips, group travel, or premium city commutes in and around Pune.',
        },
        {
            id: 3,
            question: 'Is Kia Carens available for both local and outstation rentals in Pune?',
            answer:
                'Yes, the Kia Carens is available for both local city rides and outstation travel to destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, and more.',
        },
        {
            id: 4,
            question: 'Are the rental rates for Kia Carens in Pune fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. Your rental fare includes tolls, taxes, and driver charges with no hidden costs, ensuring complete clarity.',
        },
        {
            id: 5,
            question: 'Can I book a one-way trip with Kia Carens from Pune?',
            answer:
                'Yes, Skyline Cabs provides one-way rental options with Kia Carens from Pune to major cities. Just specify your destination while booking.',
        },
        {
            id: 6,
            question: 'Is the Kia Carens suitable for corporate or group travel?',
            answer:
                'Absolutely! Kia Carens offers a premium experience for business travel, airport transfers, and group outings. It’s spacious, comfortable, and ideal for executive commutes.',
        },
        {
            id: 7,
            question: 'Are the Kia Carens vehicles clean and well-maintained?',
            answer:
                'Yes, all our Kia Carens vehicles are regularly cleaned, sanitized, and maintained for your safety and comfort. We take hygiene and vehicle quality seriously.',
        },
        {
            id: 8,
            question: 'What payment options are available for Kia Carens rental in Pune?',
            answer:
                'We accept secure online payments via UPI, credit/debit cards, net banking, as well as cash payments at the end of your ride.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Kia Carens booking in Pune?',
            answer:
                'Yes, we offer flexible modification and cancellation policies. You can make changes via our website, app, or by contacting our support team.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Kia Carens rental in Pune?',
            answer:
                'Skyline Cabs is known for its professional drivers, premium vehicle options, fair pricing, and seamless booking experience. Renting a Kia Carens with us ensures comfort, style, and peace of mind.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Rented a Kia Carens in Pune for a business trip. Extremely comfortable ride with a very professional driver. Great service from Skyline Cabs!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "The Kia Carens was spacious, clean, and ideal for our family road trip from Pune to Mahabaleshwar. Booking was quick and easy. Will definitely rent again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens on Rent in Pune",
  "image": "https://skylinecabs.com/assets/images/kia-carens-on-rent-pune.jpg",
  "description": "Rent Kia Carens in Pune with Skyline Cabs for stylish, spacious, and comfortable travel. Ideal for airport transfers, family outings, and business trips — available 24/7 with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7842"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kia-carens-on-rent-in-pune"
  }
};



      
     
      


    return (
        <div>
<Helmet>
  <title>Kia Carens on Rent in Pune | 6-Seater SUV Cab 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Rent Kia Carens in Pune with Skyline Cabs for stylish, spacious, and comfortable travel. Ideal for airport transfers, family outings, and business trips — available 24/7 with experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="Kia Carens on Rent in Pune, Rent Kia Carens Pune, Kia Carens Cab Booking Pune, SUV Car Rental Pune, 6 Seater Car Hire Pune, Family Cab Pune, Airport Carens Cab Pune, Outstation Cab Kia Carens, Skyline Cabs Pune SUV" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/67.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kiacarenceonrent;